var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "confirm",
    {
      staticClass: "small",
      attrs: {
        title: _vm.pwdTitle,
        content: _vm.content,
        showMask: _vm.showMask,
        isLoading: _vm.isLoading,
        leftBtnTxt: _vm.cancelTxt || _vm.$t("btn.cancel"),
        rightBtnTxt: _vm.submitTxt || _vm.$t("btn.submit"),
        leftBtnClick: _vm.exchange ? _vm._submit : _vm._cancle,
        rightBtnClick: _vm.exchange ? _vm._cancle : _vm._submit
      }
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c("span", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShowPWD,
            expression: "isShowPWD"
          }
        ],
        staticClass: "unlock-user",
        class: { distance: !!_vm.content }
      }),
      _vm._v(" "),
      _c(
        "form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowPWD,
              expression: "isShowPWD"
            }
          ],
          staticClass: "__input __input_row",
          attrs: { autocomplete: "off" }
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.password,
                expression: "password"
              }
            ],
            ref: "passInput",
            attrs: {
              placeholder: _vm.$t("pwdConfirm.placeholder"),
              type: "password"
            },
            domProps: { value: _vm.password },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.password = $event.target.value
              }
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("hold-pwd-view", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShowPWD && _vm.isShowHold,
            expression: "isShowPWD && isShowHold"
          }
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }